import PropTypes from 'prop-types';
import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {genericErrorHasOccurred} from '../../../actions/generic-error/action-creators';
import propLoaders from '../../../prop-loaders';
import Spinner from '../../atoms/Spinner';

export const ZepzPayinStatusWaiting = ({
    dispatch,
    initError
}) => {
    useEffect(() => {
        dispatch(genericErrorHasOccurred(true));
    }, [initError]);

    return (
        <Spinner styles={{height: '70vh'}} />
    );
};


ZepzPayinStatusWaiting.getServerSideProps = async ({
    requestId,
    sessionId,
    params: {
        paymentSessionId
    },
    query: {
        redirectResult
    }
}) => {
    try {
        const verifyResult = await propLoaders.getZepzPayinVerificationStatus(
            {
                requestId,
                sessionId,
                query: {
                    paymentSessionId,
                    redirectResult
                }
            }
        );

        return {
            redirect: verifyResult.redirectUrl
        };
    } catch (error) {
        return {
            initError: error
        };
    }
};

ZepzPayinStatusWaiting.propTypes = {
    initError: PropTypes.shape({
        message: PropTypes.string
    })
};

ZepzPayinStatusWaiting.defaultProps = {
    initError: null
};

export default connect()(ZepzPayinStatusWaiting);
